
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";



const  ExportToExcel = (apiData, fileName,className) => {
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";



    let rows = [];
    if (className == null) {
        apiData.forEach((row) => rows.push(row));
    }
    else {
        apiData.forEach((row) => rows.push(row[className]));
    }
  
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  
}
export default ExportToExcel
